/*
 * Mobile Menu
 */
function mobileMenu() {
  if(!document.querySelector('.mobile-menu')) {
    return;
  }

  const button = document.querySelector('.header__mobile-menu-button');
  const menu = document.querySelector('.mobile-menu');
  const body = document.body;

  if (!button || !menu) {
    return;
  }

  const toggleMenu = (forceState) => {
    const shouldOpen = typeof forceState === 'boolean'
      ? forceState
      : !menu.classList.contains('open');

    menu.classList.toggle('open', shouldOpen);
    button.classList.toggle('is-active', shouldOpen);
    button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    menu.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    body.classList.toggle('mobile-menu-open', shouldOpen);
  };

  button.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleMenu();
  });

  document.addEventListener('click', (e) => {
    if (!menu.classList.contains('open')) {
      return;
    }

    if (e.target.closest('.header__mobile-menu') || e.target.closest('.menu-item-has-children')) {
      return;
    }

    toggleMenu(false);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      toggleMenu(false);
    }
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      toggleMenu(false);
    });
  });
}

export default mobileMenu;
